<template>
  <v-modal
    v-model="show"
    :prevent-click="false"
    :focus-retain="true"
    :confirm-action="false"
    :cancel-action="false"
    :close-action="true"
    data-cy="sl-dialog-error"
    @confirm="confirm"
    @cancel="cancel"
  >
    <template #title>
      Erreur
    </template>

    {{ msg }}
  </v-modal>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    show: false
  }),
  methods: {
    confirm() {
      // some code...
    },
    cancel(close) {
      // some code...
      close()
    }
  }
}
</script>

